import { useMemo } from 'react';
import { useUppyEvent } from '@uppy/react';
import {
  uppyBaseOptions,
  uppyTusBaseOptions,
  useClearUppyFingerprintOnSuccess,
  useUppyAddFolderSupport,
  useUppyTus,
} from '@/utils/uppy';
import { uploadEndpointDatasetAttachments } from '@/constants/urls';

const useDatasetAttachmentsUppy = (
  code,
  { name, path: fairPath },
  fetchAttachments,
  startUpload,
  uploadRemoved,
  uploadsFail,
  uploadSuccess,
) => {
  const tusId = `dataset-attachments-${code}-${encodeURIComponent(fairPath)}`;
  const tusOptions = useMemo(
    () => ({
      ...uppyTusBaseOptions,
      id: tusId,
      endpoint: uploadEndpointDatasetAttachments(code),
      headers: {
        'ARIDHIA-FAIR-Parent-Model-ID': code,
      },
    }),
    [tusId],
  );

  const uppy = useUppyTus(uppyBaseOptions, tusOptions);

  useUppyEvent(uppy, 'upload', (_, data) => startUpload({ files: data.map(({ id }) => id) }));
  useUppyEvent(uppy, 'upload-success', (file) => uploadSuccess({ name, file }));
  useUppyEvent(uppy, 'file-removed', (file) => uploadRemoved({ file }));

  useUppyEvent(uppy, 'complete', (result) => {
    if (result?.successful.length) {
      fetchAttachments();
    }
    if (result?.failed.length) {
      uploadsFail({ files: result.failed });
    }
  });

  useUppyAddFolderSupport(uppy, fairPath);
  useClearUppyFingerprintOnSuccess(uppy, tusOptions);

  return uppy;
};

export default {
  useDatasetAttachmentsUppy,
};
